/**
 * Util para generar un reducer funcional a través de un Map, de esta manera
 * evitar el uso de switch;
 */
const createReducer = initialState => reducerMap => (state = initialState, action) => {
  const reducer = reducerMap[action.type];
  return reducer ? reducer(state, action) : state;
};

export { createReducer };
